import React from "react";
import { Modal } from "antd";

import "./AccountCreateConfirmation.scss";
import { useAppDispatch } from "../../../store/app.store.tsx";
import { setShowAccountCreateConfirmation } from "../../../store/modal.reducer.tsx";
import { useNavigate } from "react-router-dom";
import { UI_STRINGS } from "../../../constants/ui-strings.ts";

export const AccountCreateConfirmation = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleOk = () => {
    dispatch(setShowAccountCreateConfirmation(false));
    navigate("/");
  };

  return (
    <Modal
      centered
        okText={UI_STRINGS.ACCOUNT.PROCEED_BUTTON}
        closeIcon={false}
        open={true}
        title={UI_STRINGS.ACCOUNT.CREATED_TITLE}
      onOk={handleOk}
      footer={(_, { OkBtn }) => (
        <>
          <OkBtn />
        </>
      )}
    >
        <p>
          {UI_STRINGS.ACCOUNT.CREATED_MESSAGE}
        </p>
    </Modal>
  );
};
